import { Box, Text, Divider } from '@mantine/core'
import { useTranslation } from 'react-i18next'

import { Button, Modal, ModalProps } from '@percent/lemonade'
import classes from './LogVolunteeringActivityModals.module.scss'

type LogVolunteeringActivityCancellationModalProps = Pick<ModalProps, 'open'> & {
  onClose: VoidFunction
  message: string
  onConfirm: VoidFunction
}

export function LogVolunteeringActivityCancellationModal({
  open,
  onClose,
  message,
  onConfirm
}: Readonly<LogVolunteeringActivityCancellationModalProps>) {
  const { t } = useTranslation()

  return (
    <Modal borderRadiiSize="xlarge" onClose={onClose} open={open}>
      <Box className={classes.CancellationWrapper}>
        <Text className={classes.CancellationTitle}>{t('workplace_giving.wizard.confirmCancellation')}</Text>
        <Divider className={classes.Divider} />
        <Text className={classes.CancellationText}>{message}</Text>
        <Box className={classes.CancellationContentWrapper}>
          <Button variant="secondary" onClick={onClose} shape="oval">
            {t('workplace_giving.common.continueEditing')}
          </Button>
          <Button
            variant="primary"
            shape="oval"
            onClick={() => {
              onClose()
              onConfirm()
            }}
          >
            {t('workplace_giving.common.confirm')}
          </Button>
        </Box>
      </Box>
    </Modal>
  )
}
